import { Component, inject, ChangeDetectionStrategy } from "@angular/core";
import { PillboxComponent } from "@components/pillbox/pillbox.component";
import { VacsKontraktstatus } from "~app/features/virkeskop/models/kontrakt-models";
import { KontraktMediatorService } from "~app/features/virkeskop/services/kontrakt-mediator.service";

@Component({
    selector: "rask-vacs-status",
    templateUrl: "./vacs-status.component.html",
    styleUrls: ["./vacs-status.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [PillboxComponent]
})
export class VacsStatusComponent {
    private readonly kontraktMediatorService = inject(KontraktMediatorService);

    private get vacsKontraktstatus() {
        return this.kontraktMediatorService.kontrakt.vacsKontraktstatus;
    }

    protected get vacsStatusText() {
        switch(this.vacsKontraktstatus) {
            case VacsKontraktstatus.KontraktInlast:
                return "Kontrakt inläst i VACS";
            case VacsKontraktstatus.Betaln:
                return "Betalning inlagd i VACS";
            case VacsKontraktstatus.Avraknat:
                return "Kontrakt avräknat i VACS";
            case VacsKontraktstatus.Avslutat:
                return "Kontrakt avslutat i VACS";
            default:
                return undefined;
        }
    }

}
